//
//
//
//
//
//
//
//
//
//

export default {
  name: 'product-card-action-similar',
};
